import React from 'react';
import { RadioProps } from 'antd/lib';
import { StyledAppRadio } from './index.styled';

export type AppRadioProps = RadioProps;

const AppRadio: React.FC<AppRadioProps> = ({ ...props }) => (
  <StyledAppRadio {...props} />
);

export default AppRadio;
